export default __webpack_public_path__ + "static/media/AngelinaProfile2018.ee2b0934.jpg";